export default {
  // Search
  sn: 'Order No.',
  snPlaceholder: 'Enter order number',
  code_sn: 'QR Code',
  code_snPlaceholder: 'Enter QR code',
  member_nickname: 'Nickname',
  member_nicknamePlaceholder: 'Enter nickname',
  member_id: 'User ID',
  member_idPlaceholder: 'Enter user ID',
  activity_keyword: 'Activity Info',
  activity_keywordPlaceholder: 'Enter activity name or ID',
  status: 'Claim Status',
  statusPlaceholder: 'Please select',
  statusPendingShip: 'Pending Shipment',
  statusCompleted: 'Completed',
  statusFailed: 'Failed',
  statusShipped: 'Shipped',
  statusUnclaimed: 'Unclaimed',
  search: 'Search',
  // Table columns
  colSn: 'Order No.',
  colCodeSn: 'QR Code',
  colUserInfo: 'User Info',
  colActivityInfo: 'Activity Info',
  activity_name: 'Activity Name',
  activity_namePlaceholder: 'Enter activity name',
  activity_id: 'Activity ID',
  activity_idPlaceholder: 'Enter activity ID',
  colGiftName: 'Gift Name',
  colGiftNum: 'Quantity',
  colMarketPrice: 'Market Price',
  colPhone: 'Phone',
  colAddress: 'Shipping Address',
  colStatus: 'Claim Status',
  colCreatedAt: 'Created At',
  colAction: 'Action',
  // Actions
  ship: 'Ship',
  shipInfo: 'Shipment Info',
  // Placeholder
  dash: '——',
  none: 'None',
  copySuccess: 'Copied',
  copyFailed: 'Copy failed',
  // Ship modal
  shipTitle: 'Ship',
  expressCompany: 'Express Company',
  expressCompanyPlaceholder: 'Enter express company name',
  expressCompanyRequired: 'Please enter express company name',
  expressNo: 'Tracking Number',
  expressNoPlaceholder: 'Enter tracking number',
  expressNoRequired: 'Please enter tracking number',
  expressRemark: 'Remark',
  expressRemarkPlaceholder: 'Enter remark',
  expressTime: 'Shipment Time',
  ok: 'OK',
  cancel: 'Cancel',
  // Shipment info modal
  shipInfoTitle: 'Shipment Info',
  // Empty
  emptyText: 'No gift claim records',
};
